/**
 * Uploads an image file to Cloudinary and returns the secure URL
 * @param {File} file - The image file to upload
 * @returns {Promise<string>} - The secure URL of the uploaded image
 */
export const uploadImageToCloudinary = async (file, folder = "tahashoes_products") => {
  const cloudName = process.env.REACT_APP_CLOUDINARY_CLOUD_NAME || "dlsh2akhe";
  const uploadPreset = process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET || "tahashoes_preset";

  if (!file) return null;

  const formData = new FormData();
  formData.append("file", file);
  formData.append("upload_preset", uploadPreset);
  // Thư mục lưu trên Cloudinary (Tự động tạo nếu chưa có)
  formData.append("folder", folder);

  try {
    const response = await fetch(
      `https://api.cloudinary.com/v1_1/${cloudName}/image/upload`,
      {
        method: "POST",
        body: formData,
      }
    );

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error?.message || "Lỗi khi upload ảnh lên Cloudinary");
    }

    const data = await response.json();
    return data.secure_url; // Trả về link https an toàn
  } catch (error) {
    console.error("Cloudinary Upload Error:", error);
    throw error;
  }
};
